import React from 'react'
import { Typography, Button } from 'antd'
import PhoneLink from '../../PhoneLink'
const ResourceInfo = ({ name, phone, resourceId, locale, onClickResource }) => (
  <>
    <Button className='resource-profile-btn' type='link' onClick={() => onClickResource(resourceId)}>
      <Typography.Text strong>{name}</Typography.Text>
    </Button>
    <br />
    <Typography.Text>
      {`${locale.phone} `}
      {PhoneLink(phone)}
    </Typography.Text>
  </>
)

export default ResourceInfo
